import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

interface ExpiryStatus {
	passwordExpired: boolean;
	message: string;
}

@Injectable({
	providedIn: "root",
})
export class PasswordExpiryService {
	private http = inject(HttpClient);

	getPasswordExpiryInfo(): Observable<ExpiryStatus> {
		return this.http.get<ExpiryStatus>(environment.oAuthUrl + "password/status");
	}
}
